export enum Color {
  Any = 'any',
  BlackWhite = 'bw',
  White = 'ffffff',
  Black = '000000',
  Red = 'ff0000',
  Green = '00ff00',
  Blue = '0000ff',
  Grey = '7f7f7f',
  Brown = 'a52a2a',
  Orange = 'ffa500',
  Magenta = 'ff00ff',
  Purple = '800080',
  Cyan = '00ffff',
  Yellow = 'ffff00',

  ShutterstockRed = 'e72525',
  ShutterstockOrange = 'f48700',
  ShutterstockAmber = 'eca71d',
  ShutterstockYellow = 'f1f129',
  ShutterstockLime = 'a9e418',
  ShutterstockGreen = '06d506',
  ShutterstockTeal = '0ecb9b',
  ShutterstockTurquoise = '1ae0e0',
  ShutterstockAqua = '0bbbf5',
  ShutterstockAzure = '1f55f8',
  ShutterstockPurple = '7f00ff',
  ShutterstockOrchid = 'bf00ff',
  ShutterstockMagenta = 'ea06b1',

  Transparent = 'transparent',
  None = '',
}
